<!--
 * @Description: 经办人
 * @Date: 2025-05-20 18:02:01
-->
<template>
  <div class="account-info__items account-info__items">
    <BaseTextTitle class="account-info__items__title">经办人信息</BaseTextTitle>
    <BaseTextContent class="account-info__content">
      <BaseFormItem
        label="姓名"
        prop="transactorName"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          v-model="formData.transactorName"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="身份证号"
        prop="transactorCardCode"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          inputTextReplace
          :inputTexts="['英文字母', '数字']"
          v-model="formData.transactorCardCode"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="手机号"
        prop="transactorPhone"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请输入'
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="tel"
          placeholder="请输入"
          clearable
          :maxlength="11"
          v-model="formData.transactorPhone"
        ></BaseInput>
      </BaseFormItem>
      <BaseFormItem
        label="邮箱"
        prop="transactorEmail"
        :rules="[
          {
            required: true,
            trigger: 'change',
            validator: validator.validatorEmail
          }
        ]"
      >
        <BaseInput
          style="width: 100%"
          type="text"
          placeholder="请输入"
          clearable
          v-model="formData.transactorEmail"
        ></BaseInput>
      </BaseFormItem>
      <BizFormTimes
        class="account-info__block"
        label="证件有效期"
        startProp="transactorCardStartAt"
        endProp="transactorCardEndAt"
        v-model:start="formData.transactorCardStartAt"
        v-model:end="formData.transactorCardEndAt"
      />

      <BaseFormItem
        style="grid-column-start: 1; grid-column-end: 3"
        label="身份证照片（人像面）"
        prop="transactorCardZheng"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]"
      >
        <BaseUpload
          style="width: 100%"
          ref="transactorCardZhengRef"
          listType="picture-card"
          :disabled="disabled"
          :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
          :drag="false"
          :limit="1"
          :limitSize="5"
          :multiple="false"
          :auto-upload="true"
          :onError="onUploadErr"
          :http-request="uploadApi"
          :beforeRemove="
            (file, remove) => {
              remove();
              onUploadRemove('transactorCardZheng');
              return true;
            }
          "
          v-model:fileList="uploadModelMap.transactorCardZheng"
          @change="v => onUploadChange(v, 'transactorCardZheng')"
        >
          <template #tip>
            <span class="enterprise-real-form-upload">
              请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过
              5M；
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
      <BaseFormItem
        style="grid-column-start: 3; grid-column-end: 5"
        label="身份证照片（国徽面）"
        prop="transactorCardFan"
        :rules="[
          {
            required: true,
            trigger: 'change',
            message: '请上传'
          }
        ]"
      >
        <BaseUpload
          style="width: 100%"
          ref="transactorCardFanRef"
          listType="picture-card"
          :disabled="disabled"
          :accept="['.jpg', '.jpeg', '.png', '.JPG', '.JPEG', '.PNG']"
          :drag="false"
          :limit="1"
          :limitSize="5"
          :multiple="false"
          :auto-upload="true"
          :onError="onUploadErr"
          :http-request="uploadApi"
          :beforeRemove="
            (file, remove) => {
              remove();
              onUploadRemove('transactorCardFan');
              return true;
            }
          "
          v-model:fileList="uploadModelMap.transactorCardFan"
          @change="v => onUploadChange(v, 'transactorCardFan')"
        >
          <template #tip>
            <span class="enterprise-real-form-upload">
              请上传证件的彩色扫描件或照片，并确保您上传的图片信息内容清晰、可辨，单个文件大小不超过5M
            </span>
          </template>
        </BaseUpload>
      </BaseFormItem>
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import {
  BaseFormItem,
  BaseInput,
  BaseUpload,
  BaseTextContent,
  BaseTextTitle
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';
import { uploadApi } from '@/common/data-source/common/apis';
import { useUpload } from '../../hooks';
import { validator } from '@/utils';
import BizFormTimes from '@/components/biz/biz-form-times';

const { formData, formRef, disabled } = storeToRefs(infoStore());

const { uploadModelMap, onUploadErr, onUploadRemove, onUploadChange } =
  useUpload(formData, formRef, ['transactorCardZheng', 'transactorCardFan']);
</script>
